import CreateEditForm from "../components/finalForm/CreateEditForm";
import RffAddressEditingField from "../components/finalForm/inputs/RffAddressEditingField";
import RffDateField from "../components/finalForm/inputs/RffDateField";
import RffEmailField from "../components/finalForm/inputs/RffEmailField";
import RffPhoneField from "../components/finalForm/inputs/RffPhoneField";
import RffSelectField from "../components/finalForm/inputs/RffSelectField";
import RffSsnField from "../components/finalForm/inputs/RffSsnField";
import RffTextField from "../components/finalForm/inputs/RffTextField";
import RffGroup from "../components/finalForm/shared/RffGroup";
import { selectOptionsCitizenshipStatus } from "../constants/selectOptions/selectOptionsCitizenshipStatus";
import { selectOptionsMaritalStatus } from "../constants/selectOptions/selectOptionsMaritalStatus";
import { useBorrowerPortalHook } from "../hooks/useBorrowerPortalHook";

const EditBorrowerProfileData = ({
  borrowerId,
  initialValues,
  onSuccessFn,
}) => {
  const { loading, updateBorrowerProfile } = useBorrowerPortalHook();

  const onUpdate = (formData) => {
    // console.log("onUpdate", {
    //   entityId: initialValues?._id,
    //   data: formData,
    //   onSuccessFn,
    // });
    // return;
    updateBorrowerProfile({
      _id: borrowerId,
      entityId: initialValues?._id,
      data: formData,
      onSuccessFn: onSuccessFn,
    });
  };

  return (
    <CreateEditForm
      onUpdate={onUpdate}
      loading={loading}
      initialValues={initialValues}
      updateButtonText="Update Borrower"
    >
      <BorrowerProfileFormQuestions isEditing />
    </CreateEditForm>
  );
};

const BorrowerProfileFormQuestions = ({ isEditing }) => {
  return (
    <>
      <RffGroup groupLabel="Personal Information">
        <RffTextField
          size={6}
          label="First Name"
          name="firstName"
          type="text"
        />
        <RffTextField size={6} label="Last Name" name="lastName" type="text" />
        <RffTextField label="Middle Name" name="middleName" type="text" />

        <RffSsnField size={6} label="SSN" name="borrowerSSN" type="ssn" />
        <RffDateField
          size={6}
          label="Date of Birth"
          name="dateOfBirth"
          type="date"
        />

        <RffSelectField
          size={6}
          label="Marital Status"
          name="maritalStatus"
          type="select"
          options={selectOptionsMaritalStatus}
        />
        <RffSelectField
          size={6}
          label="Citizenship Status"
          name="citizenshipStatus"
          type="select"
          options={selectOptionsCitizenshipStatus}
          isLast
        />
      </RffGroup>
      <RffGroup groupLabel="Contact Information">
        <RffEmailField
          label="Email Address"
          name="emailAddress"
          type="email"
          disabled
        />
        <RffPhoneField label="Phone Number" name="phone" type="phone" />
      </RffGroup>
      <RffGroup groupLabel="Primary Address">
        <RffAddressEditingField label="Primary Address" name="primaryAddress" />
      </RffGroup>
    </>
  );
};
export default EditBorrowerProfileData;
